import "./index.css";
import type {
  ToastContainerProps} from "react-toastify";
import {
  cssTransition,
  ToastContainer as ToastContainerBase
} from "react-toastify";
import { useCallback } from "react";

export const toastContainerId = "nuco_TOAST_CONTAINER;";

const transition = cssTransition({
  enter: "nuco-toast-container--show",
  exit: "nuco-toast-container--hide",
});

/** Call methods of a Toast static class to show notifications */
export const ToastContainer = (props: ToastContainerProps) => {
  const className = useCallback(() => {
    return "nuco-toast-container";
  }, []);

  return (
    <ToastContainerBase
      className={className}
      autoClose={8000}
      closeButton={false}
      closeOnClick={false}
      draggable={false}
      hideProgressBar={true}
      icon={false}
      position={"top-right"}
      transition={transition}
      containerId={toastContainerId}
      {...props}
    />
  );
};
